// extracted by mini-css-extract-plugin
export var dataCell = "_r7-2";
export var dataRow = "_r7-0";
export var headerRow = "_r7-1";